import apiClient from "../apiClient";
import { apiNodeBaseUrl } from "../../config";

export const getServices = async () => {
    return apiClient.get(`${apiNodeBaseUrl}services`, {})
    .then(response => { return response });
}